<script>
  import Typetester from "./components.js"

  export let modes
  export let currentMode
</script>

<div class="root">
  {#each modes as mode}
    <Typetester.ModeButton {mode} bind:currentMode />
  {/each}
</div>

<style>
  .root {
    display: flex;
    flex-direction: row;
    user-select: none;
    position: relative;
    min-width: 0;
  }
</style>
